import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';

import { IDynamicVisibility, IWizardOptions } from '../../../models';
import { DateRangeMode } from 'common-lib';

//: This is a container component that combines multiple date and time fields into one UI
@Component({
    selector: 'wizard-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss', '../../form-styles.scss']
})
export class DatePickerComponent extends BaseComponent implements OnInit {
    public isActive = true;
    public datepickerClasses = ['short'];
    public showCalendar = false;
    public selectedPicker: 'range' | 'specific' = 'range';
    public dateRangeMode: DateRangeMode;
    public schedulingWindowLabel = 'Time Frame';
    public showSchedulingOptions = false;
    public isPlugin = false;
    private subscriptions: Subscription;

    constructor(private wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.isPlugin = this.wizardService.config.isPlugin;
        const mode = this.data?.mode;
        switch (mode) {
            case 'scheduling':
                this.selectedPicker = this.wizardService.options.isSpecificTime ? 'specific' : 'range';
                this.showSchedulingOptions = true;
                break;
            case 'group-class':
                this.selectedPicker = 'specific';
                this.wizardService.updateOptions({ isSpecificTime: true });
                break;
            default:
                break;
        }
        this.initSubscriptions();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    private initSubscriptions() {
        this.subscriptions = this.wizardService.dynamicVisibility$.subscribe((result: IDynamicVisibility) => {
            if (result.componentsToHide.includes('DatePicker')) {
                this.selectedPicker = 'specific';
            } else if (result.componentsToHide.includes('SpecificDatePicker')) {
                this.selectedPicker = 'range';
            }

            this.schedulingWindowLabel = this.selectedPicker === 'specific' ? 'Specific Date' : 'Time Frame';
        });

        /** There is also a listener for availabilityWindows in TimePicker,
         * but we call it again here in case the user is choosing a specific time (which remove TimePicker from the DOM)  */
        const defaultOptionsSubscription = this.wizardService.onNewDefaultOptions$.subscribe(
            (defaults: IWizardOptions) => {
                if (defaults) {
                    if (defaults.availabilityWindows) {
                        this.wizardService.updateOptions({ availabilityWindows: defaults.availabilityWindows });
                    }
                }
            }
        );

        this.subscriptions.add(defaultOptionsSubscription);
    }

    public handleSelect(type: 'range' | 'specific') {
        this.selectedPicker = type;
        const isSpecificTime = type === 'specific';
        this.schedulingWindowLabel = isSpecificTime ? 'Specific Date' : 'Time Frame';
        this.wizardService.updateOptions({ isSpecificTime });
    }

    public handleUpdateDateRangeMode(mode: DateRangeMode) {
        this.dateRangeMode = mode;
    }
}
